export const isTripSummaryIcon = (
  item: Content.Properties.TripSummaryItem,
): item is Content.Properties.TripSummaryIcon => {
  return item.$type === 'TripSummaryIconDto';
};

export const isTripSummaryText = (
  item: Content.Properties.TripSummaryItem,
): item is Content.Properties.TripSummaryText => {
  return item.$type === 'TripSummaryTextDto';
};
